import { render, staticRenderFns } from "./Assess.vue?vue&type=template&id=68bd29de&scoped=true&"
import script from "./Assess.vue?vue&type=script&lang=js&"
export * from "./Assess.vue?vue&type=script&lang=js&"
import style0 from "./Assess.vue?vue&type=style&index=0&id=68bd29de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd29de",
  null
  
)

export default component.exports